import { createRouter, createWebHistory } from "vue-router";
import App from "@/App.vue";

const routes = [
  { path: "/", component: App },
  { path: "/:type", component: App },
  { path: "/:type/:p1" , component: App},
  { path: "/:type/:p1/:p2", component: App },
  { path: "/:type/:p1/:p2/:p3", component: App },
  { path: "/:type/:p1/:p2/:p3/:p4", component: App },
  { path: "/:type/:p1/:p2/:p3/:p4/:p5", component: App },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;

